import { FC, useEffect, useRef, useState } from 'react';
import { Switch } from 'antd';
import { targetLegendIcon, detailTargetLegendIcon, targetMallShops, targetShops, targetSurrounding } from '../../ts-config';
import { isArray, isNotEmptyAny } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import cs from 'classnames';
import styles from './index.module.less';
// import { useBigdataFn } from '@/common/utils/bigdata';
import { famousBrandDataListShare, getSpotEvaluationAroundPageShare, spotEvaluationLevelPage, spotEvaluationLevelPageShare, surroundCompetitorsPagePOIDataListShare, getSpotEvaluationAroundPage, getSpotEvaluationFamousBrandPage, postSpotEvaluationCompetitorsPage, spotEvaluationCommunityMainList } from '@/common/api/spotevaluation';
import { DrawerDataProps, SpotTypeEnum } from '../../../../ts-config';
import { getShopList, getShopListShare } from '@/common/api/expandStore/shop';
import { flattenCommunityMainList } from '../communityMainList';
import { typeEnum } from '@/views/surround/pages/index/ts-config';

const LegendItem: FC<{
  item: any;
  legendData: any[];
  detail: any;
  storeChecked;
  surroundingChecked;
  setStandardShopData: (value: any) => void; // 本品牌门店数据
  setFamousBrandData: (value: any) => void;
  setCompetitorsData: (value: any) => void;
  setCommonStoreData: (value: any) => void;
  setCommonRimData: (value: any) => void;
  tenantId: string;
  isALQCommunity?: boolean;
  drawerData: DrawerDataProps;
  isOpenHeatMap: boolean;
}> = ({
  item,
  legendData,
  detail,
  storeChecked,
  surroundingChecked,
  setStandardShopData, // 本品牌门店数据
  setFamousBrandData,
  setCompetitorsData,
  setCommonStoreData,
  setCommonRimData,
  tenantId,
  isALQCommunity = false,
  drawerData,
  isOpenHeatMap
}) => {
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const storeParamsRef: any = useRef({});
  const surroundingParamsRef: any = useRef({});
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [secondChange, setSecondChange] = useState<boolean>(false);

  // https://confluence.lanhanba.com/pages/viewpage.action?pageId=172099279  默认打开本品牌门店开关
  useEffect(() => {
    const { key } = item || {};
    if (['STANDARD_SHOP', 'MALL_STANDARD_SHOP'].includes(key)) {
      setIsChecked(true);
    }
  }, [item]);

  useEffect(() => {
    const { key } = item || {};
    // 打开
    if (isChecked) {
      setIsLoading(true);
      switch (key) {
        case 'STANDARD_SHOP':
        case 'MALL_STANDARD_SHOP':
          methods.loadStandardShopData();
          break;
        case 'MALL_CHANCE_POINT':
        case 'MALL_FAMOUS_BRAND': // 知名品牌
        case 'FAMOUS_BRAND':
          methods.loadFamousBrandData(item, 1, []);
          break;
        case 'MALL_COMPETITORS': // 竞品门店
        case 'COMPETITORS':
          methods.loadCompetitionData(item, 1, []);
          break;
        case 'RESTAURANT': // 餐饮
        case 'SHOPPING': // 购物
        case 'LIFE_SERVICE': // 生活服务
        case 'EDUCATION': // 教育培训
        case 'RECREATION': // 休闲娱乐
        case 'FITNESS': // 运动健身
        case 'HOTEL': // 酒店住宿
        case 'VEHICLE_SERVICE': // 汽车服务
        case 'MALL_RESTAURANT':
        case 'MALL_SHOPPING':
        case 'MALL_LIFE_SERVICE':
        case 'MALL_EDUCATION':
        case 'MALL_RECREATION':
        case 'MALL_FITNESS':
        case 'MALL_HOTEL':
        case 'MALL_VEHICLE_SERVICE':
          methods.loadCommonApiData(item, 1, []);
          break;
        case 'ZHU_ZHAI':
        case 'GOU_WU':
        case 'BAN_GONG':
        case 'XUE_XIAO':
        case 'YI_LIAO':
        case 'JIAO_TONG':
        case 'JING_QU':
          methods.loadCommonRimApiData(item, 1, []);
          break;
      }
      return;
    }
    methods.clearTargetData(key);
  }, [item, isChecked, isALQCommunity]);

  // 经营门店二级三级变化更新
  useEffect(() => {
    if (!isNotEmptyAny(storeParamsRef.current) || !secondChange) return;
    setSecondChange(false);
    const { key } = item || {};
    switch (key) {
      case 'MALL_FAMOUS_BRAND': // 知名品牌
      case 'FAMOUS_BRAND':
        if (storeChecked.filrstLevelCode !== 'FAMOUS_BRAND') return;
        methods.loadFamousBrandData(item, 1, []);
        break;
      case 'MALL_COMPETITORS': // 竞品门店
      case 'COMPETITORS':
        if (storeChecked.filrstLevelCode !== 'COMPETITION_BRAND') return;
        methods.loadCompetitionData(item, 1, []);
        break;
      case 'RESTAURANT': // 餐饮
      case 'SHOPPING': // 购物
      case 'LIFE_SERVICE': // 生活服务
      case 'EDUCATION': // 教育培训
      case 'RECREATION': // 休闲娱乐
      case 'FITNESS': // 运动健身
      case 'HOTEL': // 酒店住宿
      case 'VEHICLE_SERVICE': // 汽车服务
      case 'MALL_RESTAURANT':
      case 'MALL_SHOPPING':
      case 'MALL_LIFE_SERVICE':
      case 'MALL_EDUCATION':
      case 'MALL_RECREATION':
      case 'MALL_FITNESS':
      case 'MALL_HOTEL':
      case 'MALL_VEHICLE_SERVICE':
        methods.loadCommonApiData(item, 1, []);
        break;
    }
  }, [storeParamsRef.current, secondChange]);

  // 周边配套二级变化更新
  useEffect(() => {
    const { key } = item || {};
    // 打开
    if (isChecked) {
      switch (key) {
        case 'ZHU_ZHAI':
        case 'GOU_WU':
        case 'BAN_GONG':
        case 'XUE_XIAO':
        case 'YI_LIAO':
        case 'JIAO_TONG':
        case 'JING_QU':
          methods.loadCommonRimApiData(item, 1, []);
          break;
      }
      return;
    }
    methods.clearTargetData(key);
  }, [surroundingParamsRef.current]);

  useEffect(() => {
    if (!(isArray(legendData) && legendData.length)) return;
    if (!item) return;
    storeParamsRef.current = {}; // 先清空
    const {
      name,
      categoryId,
      filrstLevelCode, // 除了知名品牌、竞品，其他的类型的code
      secondLevelCode, // 二级分类code
      thirdLevelCode, // 三级分类
    } = storeChecked || {};
    if (item?.name === name) {
      categoryId && (storeParamsRef.current.categoryId = categoryId);
      filrstLevelCode && (storeParamsRef.current.filrstLevelCode = filrstLevelCode);
      secondLevelCode && (storeParamsRef.current.secondLevelCode = secondLevelCode);
      thirdLevelCode && (storeParamsRef.current.thirdLevelCode = thirdLevelCode);
      setIsChecked(true);
      setSecondChange(true);
      if (!item.handSwitch) { // 如果手动打开过
        item.handSwitch = false;
      }
      item.automaticSwitch = true;
      return;
    }
    // 关掉不是手动打开的
    legendData.forEach((legendItem: any) => {
      const { handSwitch, automaticSwitch, key } = legendItem;
      if ((targetMallShops.includes(key) || targetShops.includes(key)) && !handSwitch && automaticSwitch && key === item.key) {
        setIsChecked(false);
        methods.clearTargetData(key);
      }
    });
  }, [legendData, storeChecked]);
  useEffect(() => {
    if (!(isArray(legendData) && legendData.length)) return;
    if (!item) return;
    surroundingParamsRef.current = {}; // 先清空
    const { name, aoiTypeCategoryId, secondAoiType } = surroundingChecked || {};
    if (item?.name === name) {
      aoiTypeCategoryId && (surroundingParamsRef.current.aoiTypeCategoryId = aoiTypeCategoryId); // 一级
      secondAoiType && (surroundingParamsRef.current.secondAoiType = secondAoiType); // 二级
      setIsChecked(true);
      if (!item.handSwitch) { // 如果手动打开过
        item.handSwitch = false;
      }
      item.automaticSwitch = true;
      return;
    }
    // 关掉不是手动打开的
    legendData.forEach((legendItem: any) => {
      const { handSwitch, automaticSwitch, key } = legendItem;
      if (targetSurrounding.includes(key) && !handSwitch && automaticSwitch && item.key === key) {
        setIsChecked(false);
        methods.clearTargetData(key);
      }
    });
  }, [legendData, surroundingChecked]);
  const methods = useMethods({
    handleChange: (checked: boolean) => {
      setIsChecked(checked);
      // 通知
      item.handSwitch = checked;
      item.automaticSwitch = false;
      // bigdataFn('50194f70-7037-4cc0-8c5f-aeb18fc2b614', '详情-地图-图例开关', '点击了详情-地图-图例开关', { op_block: '开店区域-详情页', op_event: ``, });
    },
    loadStandardShopData: async () => {
      // 确保drawerData是有数据的
      if (!drawerData.type) return;
      const { type, poiSearchType, lng, lat, radius, points } = drawerData || {};
      let params: any = {};
      if (type === SpotTypeEnum.Street) {
        if (poiSearchType === typeEnum.radius) { // 查询的是半径时
          params = {
            polygonQuery: 1, // 查询类型是：圆
            lng,
            lat,
            radius,
          };
        } else {
          params = {
            polygonQuery: 2, // 查询的是围栏(步行/汽车/驾车)
            points,
            lng: +lng || null,
            lat: +lat || null,
          };
        }
      }
      if (type === SpotTypeEnum.Mall) {
        params = {
          modelClusterId: drawerData?.modelClusterId,
        };
      }
      try {
        const targetFetch = drawerData?.tenantId || drawerData?.userId ? getShopListShare : getShopList;
        const targetData = await targetFetch({
          page: 1,
          size: 100, // 查询范围内的本品牌数据不会很多，100已经足够大了
          ...params,
          noDataPermission: true,
          ...(drawerData?.tenantId || drawerData?.userId ? { tenantId: tenantId, isShare: true, userId: drawerData?.userId } : {}),
        });
        const { objectList } = targetData || {};
        setStandardShopData(isArray(objectList) ? objectList : []);
      } catch (error) {};
      setIsLoading(false);
    },
    loadFamousBrandData: async (target: any, page, lastData) => {
      const sizeVal = 100;
      // 用户关闭弹窗的时候数据还在请求下一页
      if (!detail?.cityId) return;
      try {
        const api = tenantId ? famousBrandDataListShare : getSpotEvaluationFamousBrandPage;
        const { type, modelConfigId, modelClusterId } = drawerData;
        const params: any = {
          page,
          size: sizeVal,
          cityId: detail?.cityId,
          lng: detail?.lng,
          lat: detail?.lat,
          type,
          ...(storeParamsRef.current ? storeParamsRef.current : {}), // categoryId
          modelConfigId,
        };
        if (type === SpotTypeEnum.Mall) {
          params.modelClusterId = modelClusterId;
        }
        if (type === SpotTypeEnum.Street) {
          params.poiSearchType = detail?.poiSearchType;
          params.radius = detail?.radius;
          params.poiSearchMinute = detail?.poiSearchMinute;
          params.poiSearchDistance = detail?.poiSearchDistance;
          params.points = detail?.points;
        }
        if (tenantId) {
          params.tenantId = tenantId;
        }
        const { objectList, totalNum } = await api({
          ...params,
          // page,
          // size: sizeVal,
          // cityId: detail?.cityId,
          // lng: detail?.lng,
          // lat: detail?.lat,
          // ...(storeParamsRef.current ? storeParamsRef.current : {}), // categoryId
          // tenantId,
          // type: drawerData.type,
          // modelClusterId: drawerData.modelClusterId,
          // modelConfigId: drawerData.modelConfigId,
        }, {
          needCancel: false
        });
        const targetData = isArray(objectList) ? objectList : [];
        const totalData = [...lastData, ...targetData];

        // 返回的数据等于size，说明可能还有下一页
        if (targetData.length === sizeVal && totalData.length < totalNum) {
          methods.loadFamousBrandData(target, page + 1, [...lastData, ...targetData]);
        } else {
          setFamousBrandData(totalData);
          setIsLoading(false);

        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    loadCompetitionData: async (target: any, page, lastData) => {
      const sizeVal = 200;
      if (!detail?.cityId) return;
      try {
        const api = tenantId ? surroundCompetitorsPagePOIDataListShare : postSpotEvaluationCompetitorsPage;
        const params: any = {
          page,
          size: sizeVal,
          lng: detail?.lng,
          lat: detail?.lat,
          cityId: detail?.cityId,
          tenantId,
          type: drawerData.type,
          modelClusterId: drawerData.modelClusterId,
          modelConfigId: drawerData.modelConfigId,
          statusList: storeChecked.secondLevelCode ? [storeChecked.secondLevelCode] : undefined,
          // 三级
          competitionBrandTypes: storeParamsRef.current?.thirdLevelCode && isArray(storeParamsRef.current.thirdLevelCode) ? storeParamsRef.current.thirdLevelCode : null,
        };
        // 选中了开闭店
        if (storeChecked.isOpenCloseDate) {
          // 选中了开闭店
          storeChecked.shopOpenCloseTimeTypes && (params.shopOpenCloseTimeTypes = storeChecked.shopOpenCloseTimeTypes);
        }
        // else { // 非奥乐齐时，只要有三级，就赋值给shopOpenCloseTimeTypes
        //   storeChecked.shopOpenCloseTimeTypes = storeChecked.thirdLevelCode;
        // }
        if (drawerData.type === SpotTypeEnum.Street) {
          params.radius = drawerData.radius;
          isArray(drawerData?.points) && (params.points = drawerData?.points);
        }
        if (drawerData?.userId) {
          params.userId = drawerData.userId;
        }
        const { objectList, totalNum } = await api(params, {
          needCancel: false
        });
        const targetData = isArray(objectList) ? objectList : [];
        const totalData = [...lastData, ...targetData];
        // 返回的数据等于size，说明可能还有下一页
        if (targetData.length === sizeVal && totalData.length < totalNum) {
          methods.loadCompetitionData(target, page + 1, totalData);
        } else {
          setCompetitorsData(totalData);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    loadCommonApiData: async (target: any, page, lastData) => {
      const sizeVal = 200;
      if (!detail?.lng) return;
      try {
        const api = tenantId ? spotEvaluationLevelPageShare : spotEvaluationLevelPage;
        const params = {
          page,
          size: sizeVal,
          lng: detail.lng,
          lat: detail.lat,
          filrstLevelCode: target.code,
          ...(storeParamsRef.current ? storeParamsRef.current : {}), // 一二三级code
          tenantId,
          type: drawerData.type,
          // modelClusterId: drawerData.modelClusterId,
          modelConfigId: drawerData.modelConfigId,
        };
        if (drawerData.type === SpotTypeEnum.Mall) {
          params.modelClusterId = drawerData.modelClusterId;
        }
        if (drawerData.type === SpotTypeEnum.Street) {
          params.poiSearchType = detail?.poiSearchType;
          params.radius = detail?.radius;
          params.poiSearchMinute = detail?.poiSearchMinute;
          params.poiSearchDistance = detail?.poiSearchDistance;
          params.points = detail?.points;
        }
        const { objectList, totalNum } = await api(params, {
          needCancel: false
        });
        const targetData = isArray(objectList) ? objectList : [];
        const totalData = [...lastData, ...targetData];
        // 返回的数据等于size，说明可能还有下一页
        if (targetData.length === sizeVal && totalData.length < totalNum) {
          methods.loadCommonApiData(target, page + 1, totalData);
        } else {
          setCommonStoreData((state) => ({ ...state, [target.key]: totalData }));
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    loadCommonRimApiData: async (target: any, page, lastData) => {
      const sizeVal = 200;
      if (!detail?.cityName) return;
      try {
        const api = tenantId ? getSpotEvaluationAroundPageShare : getSpotEvaluationAroundPage;
        const { type, modelConfigId, modelClusterId, radius } = drawerData;
        const params: any = {
          page,
          size: sizeVal,
          aoiTypeCategoryId: target.aoiTypeCategoryId,
          lng: detail?.lng,
          lat: detail?.lat,
          cityName: detail?.cityName,
          // distance有值是poiSearchType传1，否则传null
          poiSearchType: target.distance ? 1 : null,
          ...(surroundingParamsRef.current ? surroundingParamsRef.current : {}), // 一二三级code
          type,
          radius, // 先兼容接口在type2时也要求传radius的报错
        };
        if (tenantId) {
          params.tenantId = tenantId;
        }
        if (type === SpotTypeEnum.Mall) {
          params.modelClusterId = modelClusterId;
          params.radius = target.distance;
        }
        if (type === SpotTypeEnum.Street) {
          params.modelConfigId = modelConfigId;
          params.poiSearchType = detail?.poiSearchType;
          params.radius = detail?.radius;
          params.poiSearchMinute = detail?.poiSearchMinute;
          params.poiSearchDistance = detail?.poiSearchDistance;
          params.points = detail?.points;
        }
        const useMainList = isALQCommunity && target.key === 'ZHU_ZHAI';
        const { objectList, totalNum } = useMainList ? await spotEvaluationCommunityMainList({
          page,
          size: sizeVal,
          poiSearchType: params.points?.length ? 2 : params.poiSearchType,
          lng: String(params.lng),
          lat: String(params.lat),
          radius: params.radius,
          points: params.points,
          secondAoiType: params.secondAoiType,
        }) : await api({
          ...params,
        }, {
          needCancel: false
        });
        const targetData = isArray(objectList) ? objectList : [];
        const totalData = [...lastData, ...targetData];
        // 返回的数据等于size，说明可能还有下一页
        if (targetData.length === sizeVal && totalData.length < totalNum) {
          methods.loadCommonRimApiData(target, page + 1, totalData);
        } else {
          setCommonRimData((state) => ({ ...state, [target.key]: useMainList ? flattenCommunityMainList(totalData) : totalData }));
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    clearTargetData: (key: string) => {
      // 关闭-清空对应数据
      switch (key) {
        case 'STANDARD_SHOP':
        case 'MALL_STANDARD_SHOP':
          setStandardShopData([]);
          break;
        case 'CHANCE_POINT':
        case 'MALL_FAMOUS_BRAND': // 知名品牌
        case 'FAMOUS_BRAND':
          setFamousBrandData([]);
          break;
        case 'MALL_COMPETITORS': // 竞品门店
        case 'COMPETITORS':
          setCompetitorsData([]);
          break;
        case 'RESTAURANT': // 餐饮
        case 'SHOPPING': // 购物
        case 'LIFE_SERVICE': // 生活服务
        case 'EDUCATION': // 教育培训
        case 'RECREATION': // 休闲娱乐
        case 'FITNESS': // 运动健身
        case 'HOTEL': // 酒店住宿
        case 'VEHICLE_SERVICE': // 汽车服务
        case 'MALL_RESTAURANT':
        case 'MALL_SHOPPING':
        case 'MALL_LIFE_SERVICE':
        case 'MALL_EDUCATION':
        case 'MALL_RECREATION':
        case 'MALL_FITNESS':
        case 'MALL_HOTEL':
        case 'MALL_VEHICLE_SERVICE':
          setCommonStoreData((state) => ({
            ...state,
            [key]: []
          }));
          break;
        case 'ZHU_ZHAI':
        case 'GOU_WU':
        case 'BAN_GONG':
        case 'XUE_XIAO':
        case 'YI_LIAO':
        case 'JIAO_TONG':
        case 'JING_QU':
          setCommonRimData((state) => ({
            ...state,
            [key]: []
          }));
          break;
      }
    }
  });
  return (
    <div className={styles.legendItemCon}>
      <div className={styles.iconCon}>
        <img
          src={detailTargetLegendIcon[item?.key] || targetLegendIcon[item?.key]}
          alt='icon'
          width='100%'
        />
      </div>
      <div className={cs(styles.nameCon, 'c-333 fs-12')}>
        {item?.name}
        {
          item?.distanceStr ? <>({item.distanceStr})</> : <></>
        }
      </div>
      <div>
        <Switch
          disabled={isOpenHeatMap}
          checked={isChecked}
          loading={loading}
          size='small'
          onChange={methods.handleChange}
        />
      </div>
    </div>
  );
};

export default LegendItem;
